import { Form, InputRef } from 'antd';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
import InfoForm from './InfoForm';
import { ICashierCheckPayment } from 'modules/POS/services/types/payment';
import { Modal } from '@fozito/common-ui';
import { IBillInfoResData } from 'modules/POS/services/types/bill';
import { formatPhone } from 'utils/formatPhone';
export interface IFormCheckValue {
  routingNumber: string;
  accountNumber: string;
  name: string;
  phone: string;
  address: string;
  amount: number;
  companyName: string;
  no: string;
  bankName: string;
  bankFor: string;
  dlInformation: string;
}
const FormStyled = styled(Form)`
  background: #F5F5F5;
`;
export type IFormCheckInfoDone = (data: IFormCheckValue, info: ICashierCheckPayment['checkInfo']) => void
type Props = {
  onDone: IFormCheckInfoDone;
  onCancel?: () => void;
};
type Ref = {
  open: (detail: IBillInfoResData, amount: number) => void;
};
export const useModalCheckInfoRef = () => useRef<Ref>(null);
const ModalCheckInfo = forwardRef<Ref, Props>(({ onDone, onCancel = () => undefined }, ref) => {
  const [form] = Form.useForm();
  const inputPayForRef = useRef<InputRef>(null);

  const [open, setOpen] = useState(false);
  const onClose = () => {
    setOpen(false);
    onCancel();
  };
  const onOpen: Ref['open'] = (detail, amount) => {
    setOpen(true);
    form.resetFields();
    form.setFieldsValue({
      name: detail.customerPhone,
      phone: formatPhone(detail.customerPhone),
      amount,
    });
  };

  const handleFinish = (values: any) => {
    const data = values as IFormCheckValue;
    onDone(
      data, {
      accountNumber: data.accountNumber,
      address: data.address,
      bankName: data.bankName,
      checkNumber: data.no,
      dlInformation: data.dlInformation,
      forValue: data.bankFor,
      payTo: data.companyName,
      routingNumber: data.routingNumber,
    });
    setOpen(false);
  };

  useImperativeHandle(ref, () => ({
    open: onOpen
  }));

  return (
    <Modal title='check ticket' open={open} onClose={onClose} width={'auto'} styles={{ body: { overflow: 'unset', maxHeight:'unset' } }}>
      <FormStyled layout='vertical' form={form} onFinish={handleFinish}>
        <InfoForm inputRef={inputPayForRef} onClose={onClose} />
      </FormStyled>
    </Modal>
  );
});
ModalCheckInfo.displayName = 'ModalCheckInfo';
export default ModalCheckInfo;
